var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_download_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_8821",
    "data-name": "Gruppe 8821",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4669",
    "data-name": "Pfad 4669",
    d: "M14.5,12.25V14.5h-9V12.25H4V14.5A1.5,1.5,0,0,0,5.5,16h9A1.5,1.5,0,0,0,16,14.5V12.25Zm-.75-3L12.693,8.193,10.75,10.128V4H9.25v6.128L7.307,8.193,6.25,9.25,10,13Z",
    transform: "translate(-4 -4)",
    fill: "#006b87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/Icon_Download.de91d62961726a0d66ba28cd65b40828.svg";
export { ForwardRef as ReactComponent };